/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ContactResource { 
    callId: number;
    state: string;
    insertedAt: string;
    phone: string;
    client: string;
    email: string;
    source: string;
    note: string;
    nextActionAt: string | null;
}

